import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NgxSpinnerService } from 'ngx-spinner';
import * as signalR from '@microsoft/signalr';
import * as CryptoJS from 'crypto-js';
import {
  BehaviorSubject,
  catchError,
  forkJoin,
  map,
  Observable,
  throwError,
} from 'rxjs';
import {
  BrooklynBillStatus,
  BrooklynInvestmentStatus,
  EndPoints,
  responseMessageStatus,
} from 'src/@shared/shared/enum';
import { environment, environmentURL, RetailEnvironmentURL } from 'src/environments/environment';
import { DatePipe, Location } from '@angular/common';
import { clearLocalStoragePreserving } from 'src/@shared/auth/auth-state';

@Injectable({
  providedIn: 'root',
})
export class CommonService {
  //#region properties
  isSpinning = false;
  //behvior subject for user info in header
  programPeiord: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  programsListObserver: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  listOfProgramPeriods: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  tagsObserver: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  listOfTags: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  investmentHistoryRecords: BehaviorSubject<any> = new BehaviorSubject<any>(
    null
  );
  hubConnection!: signalR.HubConnection;
  // hubconnection!: HubConnection;
  searchProgramPeriod: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  filterProgramByStatus: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  userInfoHeader: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  agencySiteDetails: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  updateSiteDetails: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  calcUserIdleTime: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  fetchDataAfterAutoLogin: BehaviorSubject<any> = new BehaviorSubject<any>(
    null
  );

  currentURL: string = '';
  previousURL: string = '';

  investmentStatus = [
    {
      statusText: 'Pending Approval',
      statusEnum: BrooklynInvestmentStatus.PendingApproval,
    },
    {
      statusText: 'Processing',
      statusEnum: BrooklynInvestmentStatus.Processing,
    },
    {
      statusText: 'Payment',
      statusEnum: BrooklynInvestmentStatus.Completed,
    },
    {
      statusText: 'Under Review',
      statusEnum: BrooklynInvestmentStatus.UnderReview,
    },
    {
      statusText: 'Canceled',
      statusEnum: BrooklynInvestmentStatus.canceled,
    },
    {
      statusText: 'Estimate Sent',
      statusEnum: BrooklynInvestmentStatus.EstimateSent,
    },
    {
      statusText: 'Invoice Sent',
      statusEnum: BrooklynInvestmentStatus.InvoiceSent,
    },
    {
      statusText: 'Invoice Paid',
      statusEnum: BrooklynInvestmentStatus.InvoicePaid,
    },
    {
      statusText: 'Voided',
      statusEnum: BrooklynInvestmentStatus.Voided,
    },
    {
      statusText: 'Deleted',
      statusEnum: BrooklynInvestmentStatus.Deleted,
    },
  ];

  paymentStatus = [
    {
      statusText: 'Pending Approval',
      statusEnum: BrooklynBillStatus.PendingApproval,
    },
    {
      statusText: 'Processing',
      statusEnum: BrooklynBillStatus.Processing,
    },
    {
      statusText: 'Payment',
      statusEnum: BrooklynBillStatus.Payment,
    },
    {
      statusText: 'Under Review',
      statusEnum: BrooklynBillStatus.CancellationUnderReview,
    },
    {
      statusText: 'Canceled',
      statusEnum: BrooklynBillStatus.canceled,
    },
    {
      statusText: 'Under Review',
      statusEnum: BrooklynBillStatus.UnderReview,
    },
    {
      statusText: 'Voided',
      statusEnum: BrooklynBillStatus.Voided,
    },
  ];

  // userLoggedIn: BehaviorSubject<any> = new BehaviorSubject<any>(false);

  lastScrollTop: any;
  isLoadingTags: boolean = false;
  isLoadingPrograms: boolean = false;
  presetDatePeriods: any[] = [
    'This Month',
    'Last Month',
    'Last 90 Days',
    'Last 6 Months',
    'This Year',
    'Last Year',
    'Last 2 Years',
  ];
  underMaintenanceDesc = '';
  //#endregion

  //#region functions
  /**
   *To do multiple POST call at same time and get result once all done the API response.
   * @param URLs_WithBody Contain array of url and body parts, Like [{ url : 'www.gmail.com', body : ''},{ url: 'www.gmail.com', body : ''}].
   * @param Options Give HTTP options Like http headers. */
  API_Post_ForkJoin(
    URLs_WithBody: Array<{ url: any; body: any }>,
    Options?: any
  ): Observable<any> {
    const observableBatch = [];
    for (let i = 0; i < URLs_WithBody.length; i++) {
      const element = URLs_WithBody[i];
      observableBatch.push(
        this._httpClient
          .post<any>(
            `${environment.apiURL}${element.url}`,
            element.body,
            Options
          )
          .pipe(
            map((res) => {
              return res;
            }),
            catchError((err) => {
              this.errorHandling(err, element.url);
              this.displayLoader(false);
              return throwError(err);
            })
          )
      );
    }
    return forkJoin(observableBatch);
  }

  /**
   * To do multiple GET call at same time and get result once all done the API response.
   * @param URL_Array - Contain array of urls, Like ['www.gmail.com', 'www.gmail.com'].
   * @param Options - Give HTTP options Like http headers.
   */
  API_GET_ForkJoin(
    URL_Array: any,
    isLoader: boolean = true,
    Options?: any
  ): Observable<any> {
    const hd = this.GetHeader();
    if (isLoader) {
      this.displayLoader(true);
    }
    const observableBatch: any = [];
    URL_Array.forEach((url: any) => {
      if (url) {
        observableBatch.push(
          this._httpClient
            .get<any>(
              `${environment.apiURL}${url}`,
              Options ? Options : { headers: hd }
            )
            .pipe(
              map((res) => {
                return res;
              }),
              catchError((err) => {
                this.errorHandling(err, url);
                this.displayLoader(false);
                return throwError(err);
              })
            )
        );
      }
    });
    return forkJoin(observableBatch);
  }

  /**
   * Use this common method for all the GET api
   * @param Url Just pass url after /api/. Predefine url will take from environment.
   * @param isLoader If you dont want to display loader in any API call send FALSE.
   * @param Options Set any other options if required.
   * @returns
   */
  API_GET(Url: any, isLoader: boolean = true, Options?: any): Observable<any> {
    const hd = this.GetHeader();
    // if (hd) {
    if (isLoader) {
      this.isSpinning = true;
      // this.displayLoader(true);
    }
    return this._httpClient
      .get<any>(
        //`${Url}`,
        `${environment.apiURL}${Url}`,
        Options ? Options : { headers: hd }
      )
      .pipe(
        map((data) => {
          this.isSpinning = false;
          // this.changeDetection.detectChanges();
          //this.displayLoader(false);
          return data;
        }),
        catchError((err) => {
          this.isSpinning = false;
          //this.displayLoader(false);
          this.errorHandling(err, Url);
          return throwError(err);
        })
      );
    // } else {
    //   return throwError('BearerToken is not present');
    // }
  }

  API_GET_Retail(Url: any, isLoader: boolean = true, Options?: any): Observable<any> {
    const hd = this.GetHeader();
    // if (hd) {
    if (isLoader) {
      this.isSpinning = true;
      // this.displayLoader(true);
    }
    return this._httpClient
      .get<any>(
        //`${Url}`,
        `${RetailEnvironmentURL.apiURL}${Url}`,
        Options ? Options : { headers: hd }
      )
      .pipe(
        map((data) => {
          this.isSpinning = false;
          // this.changeDetection.detectChanges();
          //this.displayLoader(false);
          return data;
        }),
        catchError((err) => {
          this.isSpinning = false;
          //this.displayLoader(false);
          this.errorHandling(err, Url);
          return throwError(err);
        })
      );
    // } else {
    //   return throwError('BearerToken is not present');
    // }
  }

  API_GETCOUNTRY(Url: any): Observable<any> {
    return this._httpClient.get<any>(`${Url}`);
  }

  /** Post API Method.
   * @param Url - Just pass url after /api/. Predefine url will take from environment
   * @param Body - Pass body parameter in json. Ex : { id : 1, name : Sushma, occupation : Angular Developer}
   */
  API_POST(
    Url: any,
    Body?: any,
    isLoader: boolean = true,
    Options?: any,
    responseType?: any
  ): Observable<any> {
    const hd = this.GetHeader();
    if (isLoader) {
      this.isSpinning = true;
      // this.displayLoader(true);
    }
    return this._httpClient
      .post<any>(
        `${environment.apiURL}${Url}`,
        Body,
        responseType
          ? { headers: hd, responseType: responseType }
          : Options
            ? Options
            : { headers: hd }
      )
      .pipe(
        map((data) => {
          this.isSpinning = false;
          // this.displayLoader(false);
          return data;
        }),
        catchError((err) => {
          this.isSpinning = false;
          // this.displayLoader(false);
          this.errorHandling(err, Url);
          return throwError(err);
        })
      );
  }

  API_POSTFileUpload(
    Url: any,
    Body?: any,
    isLoader: boolean = true,
    Options?: any,
    responseType?: any
  ): Observable<any> {
    const hd = this.GetFormHeader();
    if (isLoader) {
      this.isSpinning = true;
      // this.displayLoader(true);
    }
    return this._httpClient
      .post<any>(
        `${environment.apiURL}${Url}`,
        Body,
        responseType
          ? { headers: hd, responseType: responseType }
          : Options
            ? Options
            : { headers: hd }
      )
      .pipe(
        map((data) => {
          this.isSpinning = false;
          // this.displayLoader(false);
          return data;
        }),
        catchError((err) => {
          this.isSpinning = false;
          // this.displayLoader(false);
          this.errorHandling(err, Url);
          return throwError(err);
        })
      );
  }

  API_PUT(
    Url: any,
    Body: any,
    isLoader: boolean = true,
    Options?: any,
    responseType?: any
  ): Observable<any> {
    const hd = this.GetHeader();
    if (isLoader) {
      this.isSpinning = true;
      // this.displayLoader(true);
    }
    return this._httpClient
      .put<any>(
        `${environment.apiURL}${Url}`,
        Body,
        responseType
          ? { headers: hd, responseType: responseType }
          : Options
            ? Options
            : { headers: hd }
      )
      .pipe(
        map((data) => {
          this.isSpinning = false;
          // this.displayLoader(false);
          return data;
        }),
        catchError((err) => {
          this.isSpinning = false;
          // this.displayLoader(false);
          this.errorHandling(err, Url);
          return throwError(err);
        })
      );
  }
  /** Delete API Method.
   * @param Url - Just pass url after /api/. Predefine url will take from environment
   */
  API_DELETE(
    Url: any,
    isLoader: boolean = true,
    Options?: any
  ): Observable<any> {
    const hd = this.GetHeader();
    if (isLoader) {
      this.isSpinning = true;
      // this.displayLoader(true);
    }
    return this._httpClient
      .delete<any>(
        `${environment.apiURL}${Url}`,
        Options ? Options : { headers: hd }
      )
      .pipe(
        map((data) => {
          this.isSpinning = false;
          //this.displayLoader(false);
          return data;
        }),
        catchError((err) => {
          this.isSpinning = false;
          this.errorHandling(err, Url);
          return throwError(err);
        })
      );
  }
  API_DELETE_RECORDS(
    Url: any,
    Body: any,
    isLoader: boolean = true,
    Options?: any,
    responseType?: any
  ): Observable<any> {
    const hd = this.GetHeader();
    if (isLoader) {
      this.isSpinning = true;
      // this.displayLoader(true);
    }
    return this._httpClient
      .post<any>(
        `${environment.apiURL}${Url}`,
        Body,
        responseType
          ? { headers: hd, responseType: responseType }
          : Options
            ? Options
            : { headers: hd }
      )
      .pipe(
        map((data) => {
          this.isSpinning = false;
          // this.displayLoader(false);
          return data;
        }),
        catchError((err) => {
          this.isSpinning = false;
          // this.displayLoader(false);
          this.errorHandling(err, Url);
          return throwError(err);
        })
      );
  }

  /**
   * This method is used to show/hide loader
   * @param value pass True / False in value parameter to show / hide the loader respectively
   * Here is the link to npm used : https://www.npmjs.com/package/ngx-spinner
   */
  displayLoader(value: any) {
    value
      ? this._spinner.show(undefined, {
        type: 'ball-pulse',
        size: 'small',
        bdColor: 'rgb(0,0,0,0.2)',
        color: '#00000',
        fullScreen: true,
      })
      : this._spinner.hide();
  }

  /**
   * @param err pass here error  for handle by status
   */
  errorHandling(err: any, URL: any) {
    console.log(err, URL);
    if (err.status == 401) {
      this.logOut();
      this.calcUserIdleTime.next('call');
      this.displayMessage(
        'warning',
        "You're not authorized for the requested page"
      );
    } else if (err.status == 403) {
      this.displayMessage(
        'warning',
        "You're not authorized for the requested page"
      );
      this.location.back();
    } else if (err.status == 503) {
      this.calcUserIdleTime.next('call');
      this.logOut();
    } else {
      this._router.navigate(['/something-wrong']);
    }
  }

  redirectToSwitchAccount() {
    localStorage.setItem('IsSiteSelected', JSON.stringify(false));
    this._router.navigate(['/switch-account']);
  }
  // #endregion

  /**
   *
   * SetCookie Method (Locally Value set)
   * @param cname - CookieName Like 'Lst_Projects'
   * @param cvalue - CookieValue Like 'abc'
   * @param exdays - CookieExpireDays Like 360
   */
  setCookie(cname: any, cvalue: any, exdays: number) {
    const d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    const expires = 'expires=' + d.toUTCString();
    document.cookie =
      cname +
      '=' +
      cvalue +
      ';' +
      expires +
      ';domain=' +
      location.hostname.split('.').reverse().splice(0, 2).reverse().join('.') +
      ';path=/';
  }

  /**
   * GetCookie Method (Value get)
   * @param cname - CookieName Like Lst_Projects
   */
  getCookie(cname: any) {
    const name = cname + '=';
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return '';
  }
  paybevAutoLogin(formData: any) {
    const hd = this.GetAuthorizationHeader();
    return this.API_POST(EndPoints.PayBevAutoLogin, formData, false, {
      headers: hd,
    });
  }
  responseMessage(
    status: responseMessageStatus,
    messageInfo: string,
    duration?: number
  ) {
    if (status === responseMessageStatus.info) {
      this.message.info(messageInfo, {
        nzDuration: duration ? duration : 3000,
      });
    } else if (status === responseMessageStatus.warning) {
      this.message.warning(messageInfo, {
        nzDuration: duration ? duration : 3000,
      });
    } else if (status === responseMessageStatus.error) {
      this.message.error(messageInfo, {
        nzDuration: duration ? duration : 3000,
      });
    } else if (status === responseMessageStatus.success) {
      this.message.success(messageInfo, {
        nzDuration: duration ? duration : 3000,
      });
    }
  }
  baseApiUrl = 'https://file.io';
  // Returns an observable
  upload(file: any): Observable<any> {
    // Create form data
    const formData = new FormData();

    // Store form name as "file" with file data
    formData.append('file', file, file.name);

    const hd = this.GetAuthorizationHeader();
    // Make http post request over api
    // with formData as req
    return this.http.post(this.baseApiUrl, formData, { headers: hd });
  }

  /**
   * The supplier id from a /supplier/:supplierId URL, or null elsewhere (Switch Account, /account, login).
   * Sending the second path segment regardless put "undefined" or "user-profile" in the header,
   * which the API treats as a supplier the user cannot access and answers with 401.
   */
  private supplierIdFromPath(pathname: string): string | null {
    const match = /^\/supplier\/([^/]+)/.exec(pathname);
    return match ? match[1] : null;
  }

  /**
   * get the request header to pass in apis
   * @returns headers
   */
  GetHeader() {
    const tokenObj = this.getTokenObj();
    // const tenantObj = this.getTenantObj();
    const url_string = window.location.href;
    const url = new URL(url_string);

    let headers: HttpHeaders = new HttpHeaders();
    if (tokenObj) {
      const timeZoneValue = this._datepipe.transform(
        new Date(),
        'MM/dd/yyyy hh:mm:ss a'
      );
      const localTimeZoneValue =
        Intl.DateTimeFormat().resolvedOptions().timeZone;
      headers = headers.set('Content-Type', 'application/json');
      const supplierId = this.supplierIdFromPath(url.pathname);
      if (supplierId) {
        headers = headers.set('supplierid', supplierId);
      }
      // headers = headers.set("authorization", "Bearer " + tokenObj);
      headers = headers.set('timeZone', timeZoneValue!);
      headers = headers.set('localTimeZone', localTimeZoneValue);
      // Uncomment Below code and set tenantOBJ from local storage

      return headers;
    } else {
      return;
    }
  }

  GetFormHeader() {
    const tokenObj = this.getTokenObj();
    // const tenantObj = this.getTenantObj();
    let headers: HttpHeaders = new HttpHeaders();
    if (tokenObj) {
      // headers = headers.set('Content-Type', 'application/json');
      headers = headers.set('authorization', 'Bearer ' + tokenObj);
      return headers;
    } else {
      return;
    }
  }

  /**
   * get token object function
   */
  getTokenObj() {
    const localtoken = localStorage.getItem('BearerToken');
    if (localtoken) {
      return localtoken;
    } else {
      return null;
    }
  }

  /**
   *
   * @param formGroup pass formGroup name which form you want to validate
   */
  public markFormGroupTouched(formGroup: FormGroup) {
    Object.values(formGroup.controls).forEach((control) => {
      if (control.invalid) {
        control.markAsDirty();
        control.updateValueAndValidity({ onlySelf: true });
      }
    });
  }
  GetAuthorizationHeader() {
    const url_string = window.location.href;
    const url = new URL(url_string);
    const tokenObj = this.getTokenObj();
    const timeZoneValue = this._datepipe.transform(
      new Date(),
      'MM/dd/yyyy hh:mm:ss a'
    );
    const localTimeZoneValue = Intl.DateTimeFormat().resolvedOptions().timeZone;
    let headers: HttpHeaders = new HttpHeaders();
    // headers = headers.set('Content-Type', 'multipart/form-data');
    // headers = headers.set("Access-Control-Allow-Origin", '*');
    // headers = headers.set('Accept', '*/*');
    // headers = headers.set('Content-Type', 'application/json');
    if (tokenObj) {
      const supplierId = this.supplierIdFromPath(url.pathname);
      if (supplierId) {
        headers = headers.set('supplierid', supplierId);
      }
      headers = headers.set('timeZone', timeZoneValue!);
      headers = headers.set('localTimeZone', localTimeZoneValue);
      // headers = headers.set("authorization", "Bearer " + tokenObj);
    } else {
      return;
    }
    return headers;
  }
  displayMessage(type: string, message: string) {
    this.message.create(type.toString(), message, { nzDuration: 7000 });
  }
  checkAlphabets(event: any) {
    const regex = new RegExp('^[a-zA-Z]+$');
    const strInput = String.fromCharCode(
      !event.charCode ? event.which : event.charCode
    );
    if (regex.test(strInput)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }
  checkAlphabetsWithSpace(event: any) {
    const regex = new RegExp('^[a-zA-Z ]+$');
    const strInput = String.fromCharCode(
      !event.charCode ? event.which : event.charCode
    );
    if (regex.test(strInput)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }
  checkAlphaNumerics(event: any) {
    const regex = new RegExp('^[a-zA-Z0-9 ]+$');
    const strInput = String.fromCharCode(
      !event.charCode ? event.which : event.charCode
    );
    if (regex.test(strInput)) {
      if (strInput.length == 10 && strInput == '') {
        return false;
      } else {
        return true;
      }
    } else {
      event.preventDefault();
      return false;
    }
  }
  checkUserName(event: any) {
    const regex = new RegExp('^[a-zA-Z0-9]+$');
    const strInput = String.fromCharCode(
      !event.charCode ? event.which : event.charCode
    );
    if (regex.test(strInput)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }
  checkNumbers(event: any) {
    const regex = new RegExp('^[0-9]+$');
    const strInput = String.fromCharCode(
      !event.charCode ? event.which : event.charCode
    );
    if (regex.test(strInput)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }
  checkDecimalNumbers(event: any, value: any) {
    const regex = new RegExp('^[0-9.,]+$');
    const strInput = String.fromCharCode(
      !event.charCode ? event.which : event.charCode
    );
    if (!regex.test(strInput)) {
      event.preventDefault();
    }
    if (value) {
      if (value.toString().includes('.')) {
        const regex = new RegExp('^[.]+$');
        const strInput = String.fromCharCode(
          !event.charCode ? event.which : event.charCode
        );
        if (regex.test(strInput)) {
          event.preventDefault();
        }
      }
    }
  }

  getLocalStorageItem(key: string) {
    return localStorage.getItem(key);
  }

  getFormattedDate(date: any) {
    return this.datepipe.transform(date, 'MM/dd/yyyy');
  }

  getSelectedPeriod(period: any) {
    const today = new Date();

    let firstDayOfSelectedPeriod: any;
    let lastDayOfSelectedPeriod: any;
    if (period == 'Last Month') {
      const firstDayLastMonth = new Date(
        today.getFullYear(),
        today.getMonth() - 1,
        1
      );
      const lastDayLastMonth = new Date(
        today.getFullYear(),
        today.getMonth(),
        0
      );
      firstDayOfSelectedPeriod = firstDayLastMonth;
      lastDayOfSelectedPeriod = lastDayLastMonth;
    } else if (period == 'This Month') {
      const firstDayThisMonth = new Date(
        today.getFullYear(),
        today.getMonth(),
        1
      );
      const lastDayThisMonth = new Date(
        today.getFullYear(),
        today.getMonth() + 1,
        0
      );
      firstDayOfSelectedPeriod = firstDayThisMonth;
      lastDayOfSelectedPeriod = lastDayThisMonth;
    } else if (period == 'Last 90 Days') {
      const currentDate = new Date();
      currentDate.setDate(currentDate.getDate() - 90);
      firstDayOfSelectedPeriod = currentDate;
      lastDayOfSelectedPeriod = today;
    } else if (period == 'Last 6 Months') {
      const date = new Date();
      date.setMonth(date.getMonth() - 6);
      firstDayOfSelectedPeriod = date;
      lastDayOfSelectedPeriod = today;
    } else if (period == 'This Year') {
      const firstDayThisYear = new Date(today.getFullYear(), 0, 1);
      const lastDayThisYear = new Date(today.getFullYear() + 1, 0, 0);
      firstDayOfSelectedPeriod = firstDayThisYear;
      lastDayOfSelectedPeriod = lastDayThisYear;
    } else if (period == 'Last Year') {
      const firstDayLastYear = new Date(today.getFullYear() - 1, 0, 1);
      const lastDayLastYear = new Date(today.getFullYear(), 0, 0);
      firstDayOfSelectedPeriod = firstDayLastYear;
      lastDayOfSelectedPeriod = lastDayLastYear;
    } else if (period == 'Last 2 Years') {
      const firstDayLast2Years = new Date(
        today.getFullYear() - 2,
        today.getMonth(),
        today.getDate()
      );
      firstDayOfSelectedPeriod = firstDayLast2Years;
      lastDayOfSelectedPeriod = today;
    }
    return {
      firstDay: firstDayOfSelectedPeriod,
      lastDay: lastDayOfSelectedPeriod,
    };
  }
  //base64 to url for pdf-viewer
  base64ToURL(base64: any) {
    const byteArray = new Uint8Array(
      atob(base64)
        .split('')
        .map((char) => char.charCodeAt(0))
    );
    const file = new Blob([byteArray], { type: 'application/pdf' });
    const fileURL = URL.createObjectURL(file);
    return fileURL;
  }
  logOut() {
    clearLocalStoragePreserving();
    sessionStorage.clear();
    this.calcUserIdleTime.next(null);
    this.tagsObserver.next(null);
    this.programsListObserver.next(null);

    document.documentElement.style.setProperty('--theme-color', '#103F2D');
    document.documentElement.style.setProperty('--light-color', '#D7E6E0');

    // Single hard navigation to login so we don't reload the previous URL and flash back
    window.location.href = window.location.origin + '/login';
  }
  public on(eventName: string, callback: (...args: any[]) => void) {
    this.hubConnection.on(eventName, callback);
  }

  public off(eventName: string, callback: (...args: any[]) => void) {
    this.hubConnection.off(eventName, callback);
  }
  preventWhiteSpace(event: any) {
    const strInput = String.fromCharCode(
      !event.charCode ? event.which : event.charCode
    );
    if (strInput.includes(' ')) {
      event.preventDefault();
      return false;
    } else {
      return true;
    }
  }
  private key = CryptoJS.enc.Utf8.parse(environment.key);
  private iv = CryptoJS.enc.Utf8.parse(environment.iv);
  encryptData(data: string): string {
    const encryptedData = CryptoJS.AES.encrypt(data, this.key, {
      keySize: 128,
      iv: this.iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    }).toString();
    return encryptedData;
  }
  //#endregion
  constructor(
    private _httpClient: HttpClient,
    private _router: Router,
    private _spinner: NgxSpinnerService,
    private message: NzMessageService,
    private location: Location,
    private datepipe: DatePipe,
    private route: ActivatedRoute,
    private http: HttpClient,
    private _datepipe: DatePipe
  ) {
    const apiUrl = environmentURL.paybevURL + 'announcementNotifyHub';
    this.hubConnection = new signalR.HubConnectionBuilder()
      .withUrl(apiUrl)
      // .withUrl(`${environment.apiURL}+/announcementNotifyHub`)
      .withAutomaticReconnect() // Update with your URL
      .build();
  }
}
